import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import { useNavigate } from "react-router-dom";
import back from "../../../Assets/icons/move-right.svg";
import backDark from "../../../Assets/icons/move-right-dark.svg";
import { Button, message } from "antd";
import { ThemeContext } from "../../../Contexts/ThemeProvider";
import { WarningFilled } from "@ant-design/icons";
import { sendVerificationLink } from "../../../API/auth";
import { ClipLoader } from "react-spinners";

const VerificationLink = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [firstSend, setFirstSend] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const sendLink = async () => {
    setFirstSend(true);
    setLoading(true);
    try {
      const response = await sendVerificationLink();
      if (Math.floor(response.status / 100) === 2) {
        setCooldown(60);
      } else {
        message.error("ERROR OCCURED!");
        setError(true);
      }
      setCooldown(60);
    } catch (error) {
      console.error("Failed to perform necessary action", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [cooldown]);

  return (
    <div className="reset-page">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="reset">
        <div className="reset-card">
          <Button
            type="text"
            icon={
              <img
                src={isDarkMode ? backDark : back}
                alt="Back"
                className="back-icon"
              />
            }
            onClick={() => navigate("/login")}
            className="back-button"
          >
            Back
          </Button>

          <div className="title">
            {setError === true ? (
              <div className="main">Invalid Email</div>
            ) : (
              <>
                <div className="main">
                  <WarningFilled style={{ color: "#ffcc00" }} /> Email
                  Unverified
                </div>
                <div className="sub">
                  {loading ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      className="loader-container"
                    >
                      <ClipLoader
                        size={50}
                        color={"#123abc"}
                        loading={loading}
                      />
                    </div>
                  ) : firstSend ? (
                    "An Email Verification Link has been shared to your Email Address."
                  ) : (
                    "Please click the button below to receive an Email Verification Link"
                  )}
                </div>
              </>
            )}
          </div>

          <Button
            type="default"
            className="check-email-button"
            loading={loading}
            onClick={sendLink}
            disabled={cooldown > 0}
          >
            {firstSend
              ? cooldown > 0
                ? `Resend in ${cooldown}s`
                : "Resend Link"
              : "Send"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerificationLink;
